import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[3],
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            justifyContent: 'flex-start',
            margin: theme.spacing(2, 4, 2, 4)
        }
    },
    gutters: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    }
}));

export default function OptionBar(props) {
    const classes = useStyles();

    return (
        <Toolbar classes={{ root: classes.root, gutters: classes.gutters }}>
            {props.children}
        </Toolbar>
    );
};